<template>
  <div class="frb frb-info" id="truevo" v-if="isActive">
    <input ref="radio_method" autocomplete="off" type="radio" :id="`radio-button-${methodCode}`" name="radio-button"
           @click="select" :checked="methodSelected"
           :value="`${methodCode}`"/>
    <label :for="`radio-button-${methodCode}`">
      <div class="card-body">
        <div class="processingpartner_chekout">
          <ul class="list-unstyled list-inline">
            <li class="list-inline-item">
              <img src="../../../../../static/templates/img/loghi_pagamenti/mastercard_checkout.png"
                   class="img-responsive inline-block checkoutcard" alt="mastercard" height="30"/>
            </li>
            <li class="list-inline-item">
              <img src="../../../../../static/templates/img/loghi_pagamenti/visa_checkout.png"
                   class="img-responsive inline-block checkoutcard" alt="visa" height="30"/>
            </li>
          </ul>
        </div>
        <p class="small mb-1 mt-2" v-if="showInvoiceFormLink">
          <a href="#" @click.stop.prevent="onShowInvoiceForm">
            {{ $parent.wantReceiveInvoiceMessage }}
          </a>
        </p>
      </div>
    </label>

  </div>
</template>

<script>
// import Translations from "./insert-me-to-translate.vue";

import paymentMethodMixin from "../mixins/payment-method-mixin";

export default {
  mixins: [paymentMethodMixin],
  props: ['methodCode'],
  methods: {

    async payResponseHandler(response) {
      if (response.status === 200) {
        if (response.data.success === "OK") {
          if (response.data.redirect) {

            const body = response.data.body
            const form = document.createElement("form");
            form.action = response.data.redirect;
            form.method = "POST";
            form.id="truevo-cc-form"
            document.body.appendChild(form);

            // first input
            const apiKeyField = document.createElement("input");
            apiKeyField.id = "apiKey";
            apiKeyField.name = "apiKey";
            apiKeyField.value = body.apiKey;
            form.appendChild(apiKeyField);

             // first input
            const payLoadField = document.createElement("input");
            payLoadField.id = "payLoad";
            payLoadField.name = "payLoad";
            payLoadField.value = body.payLoad;
            form.appendChild(payLoadField);

             // first input
            const langField = document.createElement("input");
            langField.id = "lang";
            langField.name = "lang";
            langField.value = body.lang;
            form.appendChild(langField);

            form.submit();
          } else if (response.data.data) {
            document.location = response.data.data;
          } else {
            await this.$store.dispatch("ui/loader/hide");
            this.show_errors(null, response.data.error_message || gettext("System error. Please try again later"))
          }
        } else {
          await this.$store.dispatch("ui/loader/hide");
          this.show_errors(null, response.data.error_message || gettext("System error. Please try again later"))
        }
      } else {
        await this.$store.dispatch("ui/loader/hide");
        console.error(response);
      }
    },


  },
  mounted() {

  }
};
</script>

